/**
 * Action types for subscription operations
 */
export const SUBSCRIPTION_ACTIONS = {
	CREATE: 'wpcore_create_subscription',
	UPGRADE: 'wpcore_upgrade_subscription',
	DOWNGRADE: 'wpcore_downgrade_subscription',
};

/**
 * Action types for payment flow
 */
export const PAYMENT_ACTIONS = {
	PAYMENT_SUBSCRIPTION: 'payment-subscription',
	CONFIRM_PAY: 'confirm-pay',
	UPGRADE: 'upgrade-subscription',
	DOWNGRADE: 'downgrade-subscription',
	PAYMENT_SESSION: 'payment-session'
};

/**
 * Popup IDs used in the application
 */
export const POPUP_IDS = {
	PAYMENT_FAIL: 'payment-fail',
	UPGRADE_SUCCESS: 'upgrade-subscription-success',
	DOWNGRADE_SUCCESS: 'downgrade-subscription-success',
	PAYMENT_SUBSCRIPTION_SUCCESS: 'payment-subscription-success',
	CONFIRM_DOWNGRADE: 'confirm-downgrade-subscription',
	PAYMENT_SESSION_SUCCESS: 'booking-success',
};
